var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.19 0 0 0.19 12.24 12.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-64, -64)",
    d: "M 107.33966 6.28426 a 13.541 13.541 0 0 0 -9.9268 -4.12811 H 30.58715 a 13.541 13.541 0 0 0 -9.9268 4.12811 a 13.54241 13.54241 0 0 0 -4.12811 9.92886 v 95.57775 a 13.53376 13.53376 0 0 0 4.12811 9.925 a 13.53289 13.53289 0 0 0 9.9268 4.128 H 97.41285 a 14.09425 14.09425 0 0 0 14.05491 -14.053 V 16.21313 A 13.54241 13.54241 0 0 0 107.33966 6.28426 Z M 67.95527 120.27881 a 5.51456 5.51456 0 1 1 1.66876 -3.95127 A 5.41024 5.41024 0 0 1 67.95527 120.27881 Z m 35.02663 -19.73392 a 5.60756 5.60756 0 0 1 -5.569 5.57121 H 30.58715 a 5.60756 5.60756 0 0 1 -5.569 -5.57121 V 16.21313 a 5.60417 5.60417 0 0 1 5.569 -5.5711 H 97.41285 a 5.60417 5.60417 0 0 1 5.569 5.5711 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletExperience);
export default __webpack_public_path__ + "static/media/tablet-experience.5b1ad8d65e75bfec67cd3e734cadd179.svg";
export { ForwardRef as ReactComponent };